<template>

  <div class="row">
    <div class="col-md-6 justify-content-start align-items-center">
      <div class="col-md-2">
        <Calendar class="fw-bold" v-model="baseDate"
                  dateFormat="dd/mm/yy" :min-date="minDate"
                  @date-select="changeBaseDate"
        />
      </div>
    </div>

    <div class="col-md-6 mb-4 d-flex justify-content-end" v-if="allowReplication">
      <button type="button" class="btn btn-primary me-3"
              @click="openModal"
              :disabled="hideReplicateButton || !hasPermission('Store Availability')"
              data-bs-toggle="tooltip" title="Replicar disponibilidades">

        <i class="bi bi-copy"></i> Replicar
      </button>
    </div>
  </div>

  <div class="col-md-12 mb-6 mt-4" v-if="professionalId">
    <div class="table-responsive mt-3 pe-4">
      <table class="table table-sm table-borderless">
        <tbody>
        <tr>
          <th v-if="!hideBtnPreviousDatesProf" scope="col"
              class="text-start" @click="previousPageProf();"
              style="cursor: pointer;">
            <i class="bi bi-arrow-left text-primary"></i>
          </th>
          <th v-else></th>

          <th class="text-center" scope="col" v-for="availabilityDate in availabilityDates">
            <small>
              {{ availabilityDate.name_available_date }} <br>
              <b>
                {{
                  date(availabilityDate.available_date).format('DD')
                }}/{{ availabilityDate.name_month_available_date }}
              </b>
            </small>
            <div class="col-lg-12 ">
                <div v-if="!inserting" class="col-lg-12" style="text-align: center;">
                  <button type="button" class="btn btn-light-primary me-3"
                          v-if="hasPermission('Store AvailWeek')"
                          data-bs-toggle="tooltip" title="Adicionar Horário"
                          @click="addNewAvailWeek(availabilityDate.available_date)">
                    <i class="bi bi-plus"></i> Horário
                  </button>
                </div>
              <div v-if="inserting && availabilityDate.available_date === this.selectedDate"  class="card border border-4 mb-2" >
                <div class="card-body" style="padding: 0.5rem">
                  <AvailWeekForm
                      v-if="inserting && selectedDate === availabilityDate.available_date"
                      :form="formAvailWeek"
                      :date="availabilityDate.available_date"
                      :hideOKButton="hideOKButton"
                      @cancel="cancelAdd"
                      @ok="storeAvailWeek"
                      @blur-time-begin="validTime"
                      @blur-time-end="validTime"
                  />
                </div>
              </div>
            </div>
          </th>

          <th v-if="hideBtnNextDatesProf"></th>
          <th v-else
              scope="col" class="text-end" @click="nextPageProf();"
              style="cursor: pointer;">
            <i class="bi bi-arrow-right text-primary"></i>
          </th>
        </tr>

        <tr v-if="availabilityDates <= 0">
          <td colspan="12">
            <img :src="require('@/assets/images/thinking_face-cuate.svg')"
                 alt="Doctor" class="rounded img-fluid mx-auto d-block w-25">
            <br>
            <p class="text-center text-muted para-desc mx-auto">
                    <span class="text-dark">
                      Nenhum horário disponível.
                    </span>
              <br>
            </p>
          </td>
        </tr>

        <tr v-for="rowIdx in getMaxRows()" :key="rowIdx">
          <th></th>
          <td v-for="(availabilityDate, colIdx) in availabilityDates" :key="colIdx">
            <div v-if="availabilityDate.availabilities[rowIdx - 1]" class="card border border-2"
                 :class="{ 'bg-light': !availabilityDate.availabilities[rowIdx - 1]?.single_day}"
                 :style="getAvailabilityCardStyle(availabilityDate.availabilities[rowIdx - 1])"
                 style="min-width:200px; max-width: 300px; min-height: 60px">
              <div class="card-body" style="padding: 0.5rem">
                <div class="d-flex gap-1 justify-content-center align-items-center">
                  <span class="location-indicator me-1"
                        :style="getLocationIndicatorStyle(availabilityDate.availabilities[rowIdx - 1]?.id_place_location)"
                        :title="getLocationName(availabilityDate.availabilities[rowIdx - 1]?.id_place_location)"
                        data-bs-toggle="tooltip"></span>
                  <input :id="'time_begin_' + availabilityDate.availabilities[rowIdx - 1].id_avail_week" type="text"
                         v-mask="'##:##'"
                         placeholder="Ex. 08:00"
                         v-model="availabilityDate.availabilities[rowIdx - 1].time_begin"
                         class="form-control form-control-solid" required
                         style="text-align: center; max-width: 80px;"
                         :disabled="!hasPermission('Update AvailWeek')  || !availabilityDate.availabilities[rowIdx - 1].single_day"
                         @focus="captureBeforeAvailWeek(availabilityDate.availabilities[rowIdx - 1])"
                         @change="startUpdateAvailWeek(availabilityDate.availabilities[rowIdx - 1], availabilityDate.available_date)"
                         @blur="validTime(availabilityDate.availabilities[rowIdx - 1].time_begin, 'time_begin_' + availabilityDate.availabilities[rowIdx - 1].id_avail_week)">

                  <input :id="'time_end_' + availabilityDate.availabilities[rowIdx - 1].id_avail_week" type="text"
                         v-mask="'##:##'"
                         placeholder="Ex. 08:00"
                         v-model="availabilityDate.availabilities[rowIdx - 1].time_end"
                         class="form-control form-control-solid" required
                         style="text-align: center; max-width: 80px;"
                         :disabled="!hasPermission('Update AvailWeek') || !availabilityDate.availabilities[rowIdx - 1].single_day"
                         @focus="captureBeforeAvailWeek(availabilityDate.availabilities[rowIdx - 1])"
                         @change="startUpdateAvailWeek(availabilityDate.availabilities[rowIdx - 1], availabilityDate.available_date)"
                         @blur="validTime(availabilityDate.availabilities[rowIdx - 1].time_end, 'time_end_' + availabilityDate.availabilities[rowIdx - 1].id_avail_week)">

                  <h6 class="mt-3">{{availabilityDate.availabilities[rowIdx - 1].interval_minutes}} Min</h6>

                  <button type="button"
                          class="btn btn-icon btn-bg-light btn-active-color-primary mt-2"
                          style="padding: 0.2rem; width: 2rem; height: 2rem;"
                          v-if="hasPermission('Delete AvailWeek') && availabilityDate.availabilities[rowIdx - 1].single_day"
                          :disabled="!availabilityDate.availabilities[rowIdx - 1].single_day"
                          @click="deleteAvailWeek(availabilityDate.availabilities[rowIdx - 1])"
                          data-bs-toggle="tooltip" title="Excluir Disponibilidade">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>

                <div v-if="selectedAvailWeekId===availabilityDate.availabilities[rowIdx - 1].id_avail_week && hasPermission('Update AvailWeek')" class="d-flex gap-2 mt-2 justify-content-center align-items-center">
                  <button type="button" class="btn btn-light me-2" @click="cancelUpdateAvailWeek(availabilityDate.availabilities[rowIdx - 1])">
                    Cancelar
                  </button>
                  <button type="button" class="btn btn-primary" @click="updateReturn(availabilityDate.availabilities[rowIdx - 1])">
                    OK
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="card" style="padding: 0.5rem; min-width:250px; max-width: 300px; min-height: 50px">
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
  <div v-else>
    <p class="text-center">Nenhuma informação disponível</p>
  </div>

  <ModalProfSpecSelect
      :specialties="this.specialties.filter(specialty => specialty.id_spec !== this.specId)"
      @onReplicate="replicate"
      id="ModalProfSpecSelectAvailPeriod"
  />
</template>

<script>
import http from "../../../../helpers/http";
import Calendar from "primevue/calendar";
import {mask} from "vue-the-mask";
import Utils from "@/helpers/utils";
import Alert from "@/helpers/alert";
import Permission from "../../../../helpers/permission";
import AvailWeekForm from "@/views/calendar/release_times/tab/AvailWeekForm.vue";
import ModalProfSpecSelect from "@/views/calendar/release_times/tab/ModalProfSpecSelect.vue";
import { generateColorFromId } from "@/helpers/colorGenerator";

export default {
  name: "AvailPeriod",
  directives: {
    mask,
  },
  components: {
    ModalProfSpecSelect,
    Calendar,
    AvailWeekForm,
  },
  emits: ["onRefreshed"],
  props: {
    professional: null,
    professionalId: null,
    specId: null,
    releaseFor: String,
    allowReturn: Boolean,
    refresh: Boolean,
    intervalMinutes: Number,
    specialties: Array,
    allowReplication: Boolean,
    selectedLocationId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      availabilityDates: [],
      selectedHours: new Set(),
      inserting: false,
      hideOKButton: false,
      hideReplicateButton: false,
      expandedTimesProf: false,
      hideBtnPreviousDatesProf: true,
      hideBtnNextDatesProf: false,
      baseDate: new Date(),
      minDate: new Date(),
      selectedAvailWeekId: '',
      beforeAvailWeek: '',
      selectedDate: '',

      formAvailWeek: {
        id_avail: '',
        week_day: '',
        time_begin: '',
        time_end: '',
        allow_return: '',
        release_for: '',
        interval_minutes: '',
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    locations() {
      return this.$parent.locations || [];
    },
  },
  watch: {
    refresh(newvalue, oldvalue) {
      if ((newvalue ?? false) && this.specId) {
        this.getDates();
        this.$emit('onRefreshed');
      }
    },
  },
  methods: {
    date: moment,
    hasPermission(permission) {
      return Permission.has(permission);
    },
    getMaxRows() {
      if (!this.availabilityDates || this.availabilityDates.length === 0) return 0;
      return Math.max(...this.availabilityDates.map(d => d.availabilities?.length || 0));
    },
    validTime(time, elementId) {
      if (time && !Utils.isValidTime(time)) {
        Alert.toastError('Formato de hora inválido. Utilize HH:MM!');
        document.getElementById(elementId).focus();
      }
    },
    captureBeforeAvailWeek(availWeek) {
      if (this.beforeAvailWeek?.id_avail_week ?? '' !== availWeek?.id_avail_week) {
        this.beforeAvailWeek = JSON.parse(JSON.stringify(availWeek));
      }
    },
    addNewAvailWeek(availDate) {
      this.inserting = true;
      this.selectedDate = availDate;
      this.formAvailWeek.id_avail = '';
      const jsDay = this.date(availDate).day();
      this.formAvailWeek.week_day = jsDay === 0 ? 1 : jsDay + 1;
      this.formAvailWeek.allow_return = this.allowReturn;
      this.formAvailWeek.release_for = this.releaseFor;
      this.formAvailWeek.interval_minutes = this.intervalMinutes;
    },
    cancelAdd() {
      this.inserting = false;
      this.selectedDate = '';
    },
    startUpdateAvailWeek(availWeek, availDate) {
      this.selectedAvailWeekId = availWeek?.id_avail_week;
      this.selectedDate = availDate;
    },
    cancelUpdateAvailWeek(availWeek) {
      let availDateIdx = this.availabilityDates.findIndex(item => item.available_date === this.selectedDate);
      if (availDateIdx !== -1) {
        let availabilities = this.availabilityDates[availDateIdx].availabilities;
        let idx = availabilities.findIndex(item => item.id_avail_week === availWeek.id_avail_week);
        if (idx !== -1) {
          this.availabilityDates[availDateIdx].availabilities[idx] = JSON.parse(JSON.stringify(this.beforeAvailWeek));
        }
      }
      this.selectedAvailWeekId = '';
      this.selectedDate = '';
      this.beforeAvailWeek = '';
    },
    updateReturn(availWeek) {
      this.updateAvailWeek(availWeek);
    },
    updateAvailWeek(availWeek) {
      let data = {
        'id_avail': availWeek?.id_avail,
        'week_day': availWeek?.week_day,
        'time_begin': availWeek?.time_begin.substring(0, 5),
        'time_end': availWeek?.time_end.substring(0, 5),
        'allow_return': availWeek?.allow_return,
        'release_for': this.releaseFor,
        'interval_minutes': availWeek?.interval_minutes,
      };
      http.put(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/${availWeek.id_avail}/availability-weeks/${availWeek.id_avail_week}`, data).then((response) => {
        this.selectedAvailWeekId = '';
        this.selectedDate = '';
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
      });
    },
    async storeAvailWeek() {
      this.hideOKButton = true;

      if (this.releaseFor !== 'O') {
        const params = {
          id_spec: this.specId,
          release_for: this.releaseFor,
          allow_return: this.allowReturn,
          date_begin: this.selectedDate,
          date_end: this.selectedDate,
          time_begin: this.formAvailWeek.time_begin,
          time_end: this.formAvailWeek.time_end,
          id_place_location: this.selectedLocationId ?? null,
        };

        try {
          const conflictResponse = await http.get(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/check-conflict`, { params });
          
          if (conflictResponse.data.has_conflict) {
            const conflicting = conflictResponse.data.conflicting_avail_week;
            const locationName = conflicting.location_name || this.getLocationName(conflicting.id_place_location);
            const message = `Este horário já está liberado para a unidade "${locationName}". ` +
                           `Não é possível ter o mesmo horário liberado para mais de uma unidade.`;
            
            await Swal.fire({
              title: 'Conflito de Horário',
              text: message,
              icon: 'warning',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
            
            this.hideOKButton = false;
            return;
          }
        } catch (e) {
          console.error('Erro ao verificar conflito:', e);
        }
      }

      if (this.releaseFor !== 'O') {
        this.formAvailWeek.id_place_location = this.selectedLocationId ?? null;
      }
      
      let formAvail = {
        avail_date_begin: this.selectedDate,
        avail_date_end: this.selectedDate,
        id_spec: this.specId,
        avail_online: this.releaseFor === 'B' ? false : this.releaseFor === 'O',
        avail_week: this.formAvailWeek,
        avail_type: 'FI',
      }

      http.post(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities`, formAvail).then((response) => {
        this.refreshDateData(this.selectedDate).then(() => {
          this.inserting = false;
          this.hideOKButton = false;
          this.selectedDate = '';
          this.formAvailWeek = {
            id_avail: '',
            week_day: '',
            time_begin: '',
            time_end: '',
            allow_return: '',
            release_for: '',
            interval_minutes: ''
          }
        });
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        this.hideOKButton = false;
      });
    },
    deleteAvailWeek(availWeek) {
      http.delete(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/${availWeek.id_avail}/availability-weeks/${availWeek.id_avail_week}`, {data: {release_for: this.releaseFor}}).then((response) => {
        Alert.toastInfo('Disponibilidade excluída com sucesso!');
        let availDateIdx = this.availabilityDates.findIndex(item => item.available_date === availWeek.available_date);
        if (availDateIdx !== -1) {
          let availabilities = this.availabilityDates[availDateIdx].availabilities;
          let idx = availabilities.findIndex(item => item.id_avail_week === availWeek.id_avail_week);
          if (idx !== -1) {
            availabilities.splice(idx, 1);
          }
        }
        this.getDates();
      }).catch(e => {
        console.log(e);
        this.getDates();
      });
    },
    nextPageProf() {
      let availabilityDates = this.availabilityDates;

      let startAvailability = availabilityDates[1];
      let endAvailability = availabilityDates[availabilityDates.length - 1];
      if (!startAvailability) {
        this.hideBtnNextDatesProf = true;
        return;
      }

      let startDate = startAvailability.available_date;
      let endDate = endAvailability.available_date;
      http.get(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/all-dates`, {
        params: {
          date_begin: this.date(startDate).format('YYYY-MM-DD'),
          date_end: this.date(endDate).add(1, 'day').format('YYYY-MM-DD'),
          id_spec: this.specId,
          avail_online: this.releaseFor === 'B' ? null : this.releaseFor === 'O',
          allow_return: this.allowReturn,
        }
      }).then((response) => {
        this.baseDate = this.date(startAvailability.available_date).toDate();
        let availability = response.data;
        this.hideBtnNextDatesProf = false
        this.hideBtnPreviousDatesProf = false;
        this.availabilityDates = availability;
      });
    },
    previousPageProf() {
      let availabilityDates = this.availabilityDates;
      let startAvailability = availabilityDates[0];
      let endAvailability = availabilityDates[availabilityDates.length - 1];

      http.get(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/all-dates`, {
        params: {
          date_begin: this.date(startAvailability.available_date).add(-1, 'day').format('YYYY-MM-DD'),
          date_end: this.date(endAvailability.available_date).add(-1, 'day').format('YYYY-MM-DD'),
          id_spec: this.specId,
          avail_online: this.releaseFor === 'B' ? null : this.releaseFor === 'O',
          allow_return: this.allowReturn,
        }
      }).then((response) => {
        this.baseDate = this.date(startAvailability.available_date).toDate();
        let availability = response.data;
        let firstDate = availability[0].available_date;
        this.hideBtnPreviousDatesProf = this.date(firstDate) <= this.date();
        this.hideBtnNextDatesProf = false
        this.availabilityDates = availability;
      });
    },
    getDates() {
      this.availabilityDates = null;

      let params = {
        date_begin: this.date(this.baseDate).format('YYYY-MM-DD'),
        date_end: this.date(this.baseDate).add(3, 'day').format('YYYY-MM-DD'),
        id_spec: this.specId,
        avail_online: this.releaseFor === 'B' ? null : this.releaseFor === 'O',
        allow_return: this.allowReturn,
      };

      return http.get(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/all-dates`, {params: params}).then((response) => {
        this.availabilityDates = response.data;
      });
    },
    changeBaseDate() {
      this.getDates();
    },
    getLocationIndicatorStyle(locationId) {
      const color = generateColorFromId(locationId);
      return {
        backgroundColor: color,
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        display: 'inline-block',
        border: '2px solid white',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
      };
    },
    getAvailabilityCardStyle(availability) {
      if (!availability) return {};
      const color = generateColorFromId(availability.id_place_location);
      return {
        borderLeft: `4px solid ${color}`,
      };
    },
    getLocationName(locationId) {
      if (!locationId) {
        return this.place?.place_name || 'Local Principal';
      }
      const location = this.locations.find(loc => loc.id_place_location === locationId);
      return location ? (location.location_nickname || location.location_name) : '';
    },
    refreshDateData(date) {
      const params = {
        date_begin: this.date(date).format('YYYY-MM-DD'),
        date_end: this.date(date).format('YYYY-MM-DD'),
        id_spec: this.specId,
        avail_online: this.releaseFor === 'B' ? null : this.releaseFor === 'O',
        allow_return: this.allowReturn,
      };

      return http.get(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/all-dates`, {params: params}).then((response) => {
        const refreshedData = response.data;
        if (refreshedData && refreshedData.length > 0) {
          const refreshedDate = refreshedData[0];
          const dateIndex = this.availabilityDates.findIndex(d => d.available_date === date);
          if (dateIndex >= 0) {
            this.availabilityDates.splice(dateIndex, 1, refreshedDate);
          } else {
            this.availabilityDates.push(refreshedDate);
            this.availabilityDates.sort((a, b) => a.available_date.localeCompare(b.available_date));
          }
        }
      });
    },
    openModal() {
      const modal = new bootstrap.Modal(document.getElementById('ModalProfSpecSelectAvailPeriod'));
      modal.show();
    },
    closeModal() {
      const modalElement = document.getElementById('ModalProfSpecSelectAvailPeriod');
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    },
    replicate(specs) {
      const startDate = this.date(this.availabilityDates?.[0]?.available_date).format('YYYY-MM-DD');
      const endDate = this.date(this.availabilityDates?.[this.availabilityDates?.length - 1]?.available_date).format('YYYY-MM-DD');
      const today = this.date().format('YYYY-MM-DD');
      Swal.fire({
        title: 'Informe o período que deseja replicar:',
        text: "Ao replicar todas as liberações para as especialidades selecionadas serão substituídas, confirma a replicação?",
        html:
            `<label>Data inicial:</label><br>
             <input id="swal-input-start" type="date" class="swal2-input" value="${startDate}"><br>
             <label>Data final:</label><br>
             <input id="swal-input-end" type="date" class="swal2-input" value="${endDate}">`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, replicar!',
        cancelButtonText: 'Fechar',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: 'btn btn-secundary'
        },
        preConfirm: () => {
          const startDate = Swal.getPopup().querySelector('#swal-input-start').value;
          const endDate = Swal.getPopup().querySelector('#swal-input-end').value;
          if (!startDate || !endDate) {
            Swal.showValidationMessage('Preencha ambas as datas');
            return false;
          }
          if (this.date(startDate).isAfter(this.date(endDate))) {
            Swal.showValidationMessage('Data inicial não pode ser maior que a data final');
            return false;
          }
          if (this.date(startDate).isBefore(today)) {
            Swal.showValidationMessage('Data inicial deve ser maior ou igual à data atual');
            return false;
          }
          return { startDate, endDate };
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.hideReplicateButton = true;
          const payload = {
            start_date: result.value.startDate,
            end_date: result.value.endDate,
            allow_return: this.allowReturn,
            release_for: this.releaseFor,
            id_spec: this.specId,
            specs: specs
          };

          console.log(payload);

          http.patch(`/places/${this.place.id_place}/professionals/${this.professionalId}/availabilities/replicate-period`, payload).then((response) => {
            this.hideReplicateButton = false;
            this.closeModal();
            Alert.toastSuccess('Replicação realizada com sucesso!');
          }).catch(e => {
            Alert.toastError(e.response.data.message ?? e.response.data);
            this.hideReplicateButton = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.location-indicator {
  flex-shrink: 0;
  cursor: help;
}
</style>